(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('PropriedadeMapCtrl', PropriedadeMap);

  PropriedadeMap.$inject = [
    'LeafletService',
    '$scope',
    '$routeParams'
  ];

  // eslint-disable-next-line space-before-function-paren, max-lines-per-function
  function PropriedadeMap (LeafletService, $scope, $routeParams) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.leaflet = null;
    vm.propriedade = $scope.$root.currentPropriedade;
    vm.bounds = LeafletService.getBounds([...vm.propriedade.bounds.north_east].reverse(),
      [...vm.propriedade.bounds.south_west].reverse());
    vm.polygons = {};

    //////////////////////////////////////////
    // Bindable methods
    vm.boundsCenter = BoundsCenter;

    //////////////////////////////////////////
    // Function declarations

    function BoundsCenter() {
      const center = vm.bounds.getCenter();

      return [center.lat, center.lng];
    }

    function getCor(glebaId) {
      return ($scope.culturasPorGleba[glebaId] || {}).cor || '#fff';
    }

    function getPolygonConfig(glebaId) {
      return {
        filtered: ($scope.culturasPorGleba[glebaId] || {}).filtered
      };
    }

    // eslint-disable-next-line max-lines-per-function
    function MakeGlebasPlygons() {
      if ($scope.culturasPorGleba) {
        // eslint-disable-next-line max-lines-per-function
        vm.propriedade.glebas.forEach((gleba) => {
          const cor = getCor(gleba.id);
          if (vm.polygons[gleba.id]) {
            const originalOptions = GetPolygonsOptions(null, cor, getPolygonConfig(gleba.id));
            vm.polygons[gleba.id].polygon.setStyle(originalOptions.options);
          } else {
            const polygon = LeafletService.generatePolygon(GetPolygonsOptions(gleba, cor, getPolygonConfig(gleba.id)));
            polygon.on('click', (event) => {
              $scope.$emit('glebaPolygonClick', {
                event,
                polygon,
                gleba
              });
            });
            polygon.on('dblclick', (event) => {
              $scope.$emit('glebaPolygonDblClick', {
                event,
                polygon,
                gleba
              });
            });
            const tooltip = L.tooltip({
              sticky: true,
              offset: [20, 0],
              direction: 'right'
            }).setContent(gleba.descricao);
            polygon.bindTooltip(tooltip);
            vm.polygons[gleba.id] = {
              gleba: gleba,
              polygon: polygon
            };
            LeafletService.addToMap(polygon, 'propriedade-map');
          }
        });

        if ($scope.customGlebaPolygonOptions) {
          SetCustomGlebasPolygonsOptions();
        }

        if ($routeParams.activeGleba) {
          ToggleGlebaFocus($routeParams.activeGleba, null);
        }
      }
    }

    function SetCustomGlebasPolygonsOptions() {
      if ($scope.customGlebaPolygonOptions) {
        if ($scope.culturasPorGleba && Object.keys(vm.polygons).length) {
          Object.entries($scope.customGlebaPolygonOptions).forEach(([gleba, options]) => {
            vm.polygons[gleba].polygon.setStyle(options);
          });
        }
      } else {
        MakeGlebasPlygons();
      }
    }

    function GetPolygonsOptions(gleba, cor, config) {
      const filtered = (config || {}).filtered;
      return {
        coordinates: gleba && gleba.coordinates.map(
          (coordinateGroup) => coordinateGroup.map((coordinate) => [coordinate[1], coordinate[0]])
        ),
        options: {
          color: cor,
          fillColor: cor,
          fillOpacity: filtered ? 0.5 : 0.2,
          opacity: 1,
          weight: filtered ? 4 : 1
        }
      };
    }

    function RemoveMap() {
      vm.leaflet && vm.leaflet.remove();
      vm.leaflet = null;
    }

    function RefreshMap() {
      vm.leaflet.invalidateSize({
        animate: true
      });
      if ($scope.focusedGleba) {
        ToggleGlebaFocus($scope.focusedGleba);
      }
    }

    function ToggleGlebaFocus(gleba, oldGleba) {
      if (vm.leaflet) {
        const polygon = vm.polygons[gleba];
        const oldPolygon = vm.polygons[oldGleba];

        if (polygon) {
          polygon.polygon.setStyle({
            weight: 4,
            color: '#fff'
          });
          vm.leaflet.fitBounds(polygon.polygon.getBounds());
        } else {
          vm.leaflet.fitBounds(vm.bounds);
        }

        if (oldPolygon) {
          oldPolygon.polygon.setStyle({
            weight: 1,
            color: oldPolygon.polygon.options.fillColor
          });
        }
      }
    }

    function SetMarkers(markers, oldMarkers) {
      oldMarkers.forEach((marker) => {
        if (marker && marker.marker && marker.marker.addTo) {
          marker.marker.remove();
        }
      });
      markers.forEach((marker) => {
        if (marker && marker.marker && marker.marker.addTo) {
          LeafletService.addToMap(marker.marker, 'propriedade-map');
        }
      });
    }

    function SetPolylines(polylines, oldPolylines) {
      oldPolylines.forEach((polyline) => {
        polyline.remove();
        if (polyline.decorator) {
          polyline.decorator.remove();
        }
        if (polyline.startEndMarkers && polyline.startEndMarkers.length) {
          polyline.startEndMarkers.forEach((marker) => marker.remove());
        }
      });

      if (polylines.length) {
        polylines.forEach((polyline) => {
          LeafletService.addToMap(polyline, 'propriedade-map');
          if (polyline.decorator) {
            LeafletService.addToMap(polyline.decorator, 'propriedade-map');
          }
          if (polyline.startEndMarkers && polyline.startEndMarkers.length) {
            polyline.startEndMarkers.forEach((marker) => LeafletService.addToMap(marker, 'propriedade-map'));
          }
        });
      }
    }

    function SetAdditionalPolygons(polygons = [], oldPolygons = []) {
      polygons = _.flatten(polygons);
      oldPolygons = _.flatten(oldPolygons);

      oldPolygons.forEach((polygon) => {
        if (polygon) {
          polygon.remove();
        }
      });
      polygons.forEach((polygon) => {
        if (polygon) {
          LeafletService.addToMap(polygon, 'propriedade-map');
        }
      });
    }

    function SingleImageOverlay(data) {
      if (vm.singleImageLayer) {
        vm.singleImageLayer.remove();
        vm.singleImageLayer = null;
        return;
      }
      if (!(data || {}).url) {
        return;
      }
      vm.singleImageLayer = L.imageOverlay(data.url, data.bounds, {
        opacity: 0.7,
        zIndex: 9999
      });
      LeafletService.addToMap(vm.singleImageLayer, 'propriedade-map');
    }

    function SetImageOverlays(images = [], oldImages = []) {
      $scope.$emit('singleImageOverlay');
      oldImages.forEach((img) => {
        if (img && img.layer) {
          vm.polygons[img.gleba].polygon.setStyle({
            fillOpacity: 0.2
          });
          img.layer.remove();
        }
      });
      images.forEach((img) => {
        if (img) {
          vm.polygons[img.gleba].polygon.setStyle({
            fillOpacity: 0
          });
          img.layer = L.imageOverlay(img.url, getImageBounds(img.gleba), {
            opacity: 1,
            interactive: true,
            zIndex: 9998
          });
          img.layer.on('click', (event) => {
            $scope.$root.$emit('clickMapLayer', event);
          });
          LeafletService.addToMap(img.layer, 'propriedade-map');
        }
      });
    }

    function getImageBounds(gleba) {
      return LeafletService.boundsFromCoordinates(vm.polygons[gleba].gleba.coordinates);
    }

    function MapFocusPolygons(polygons) {
      if (vm.leaflet) {
        let glebas = (polygons || []).map((id) => vm.polygons[id].polygon);
        if (!glebas.length || !polygons) {
          glebas = Object.values(vm.polygons).map((gleba) => gleba.polygon);
        }
        if (glebas.length) {
          const bounds = glebas.reduce((b, gleba) => {
            b.extend(gleba.getBounds());
            return b;
          }, glebas[0].getBounds());
          vm.leaflet.fitBounds(bounds);
        }
      }
    }

    //////////////////////////////////////////
    // Controller logic

    // Add required Roboto font for Info Windows
    if (!document.querySelector('link[href*=Roboto]')) {
      const fontLink = document.createElement('link');
      fontLink.href = 'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700';
      fontLink.type = 'text/css';
      fontLink.rel = 'stylesheet';
      document.head.appendChild(fontLink);
    }

    let viewportChangedEvent;
    $scope.$on('leafletMapComplete', (event, map) => {
      vm.leaflet = map;
      vm.leaflet.on('click', (eventClick) => {
        $scope.$emit('leafletMapClick', eventClick);
      });
      vm.leaflet.zoomControl.setPosition('bottomright');
      viewportChangedEvent = $scope.$on('viewportChanged', () => {
        RefreshMap();
      });
    });

    $scope.$on('$routeChangeStart', () => {
      viewportChangedEvent && viewportChangedEvent();
      RemoveMap();
    });

    $scope.$on('leafletResetMap', () => {
      if (vm.leaflet) {
        RefreshMap();
        vm.leaflet.fitBounds(vm.bounds);
      }
    });

    $scope.$on('leafletClosePopup', () => {
      if (vm.leaflet) {
        vm.leaflet.closePopup();
      }
    });

    $scope.$watch('culturasPorGleba', MakeGlebasPlygons);

    $scope.$watch('customGlebaPolygonOptions', SetCustomGlebasPolygonsOptions);

    $scope.$watch('focusedGleba', ToggleGlebaFocus);

    $scope.$watch('markers', SetMarkers);

    $scope.$watch('polylines', SetPolylines);

    $scope.$watchGroup(['additionalPolygons', 'defaultPolygons'], SetAdditionalPolygons);

    $scope.$watch('imageOverlays', SetImageOverlays);
    $scope.$watch('singleImageOverlay', SingleImageOverlay);

    $scope.$on('mapFocusPolygons', (event, data) => MapFocusPolygons(data));
  }
}());
